<template>
  <div>
    <confirmation-header-text class="ml-1" icon="mdi-alpha-d-box"
                              text="Diplomatic Details"></confirmation-header-text>

    <v-layout row wrap class="mx-lg-6">
      <v-layout row wrap v-if="!isOld">

        <v-flex xs3>
          <list-item-detail :sub_title="application_data.diplomatic_mission_name"
                            title="Diplomatic Mission Name"></list-item-detail>
        </v-flex>
        <v-flex xs3>
          <list-item-detail :sub_title="application_data.position"
                            title="Position in Diplomatic Mission"></list-item-detail>
        </v-flex>
        <v-flex xs3>
          <list-item-detail :sub_title="purpose_of_visa"
                            title="Purpose of Visa"></list-item-detail>
        </v-flex>
      </v-layout>

      <v-layout row wrap v-else>
        <v-flex xs3>
          <list-item-detail :sub_title="application_data.hotel_name"
                            title="Name of Hotel"></list-item-detail>
        </v-flex>
        <v-flex xs3>
          <list-item-detail :sub_title="application_data.hotel_address"
                            title="Address of Hotel"></list-item-detail>
        </v-flex>

      </v-layout>
    </v-layout>
  </div>
</template>

<script>
import ListItemDetail from "../../ListItemDetail";
import ConfirmationHeaderText from "../../ConfirmationHeaderText";

export default {

  components: {
    ListItemDetail, ConfirmationHeaderText
  },
  computed: {
    application_data() {
      return this.$store.state.VisaRequestSingle.visaRequest.extra.application_data;
    },
    purpose_of_visa() {
      return this.$store.state.VisaRequestSingle.visaRequest.purpose_of_visa;
    },
    isOld() {
      return this.$store.state.VisaRequestSingle.visaRequest.old;
    },
  },
};
</script>

